import campaign from "constants/best-in-travel/2025/index";
import { FacebookFlat } from "@icons/social/facebook";
import { X } from "@icons/social/x";

import { keyify } from "@utils/keyify";

export const pivots = {
  countries: "countries",
  regions: "regions",
  cities: "cities",
};

export const engine = {
  platforms: [
    {
      // TODO - Review the Post it says 2024
      name: "Facebook",
      url: ({ url }) =>
        `https://www.facebook.com/dialog/share?app_id=111537044496&display=popup&href=${encodeURIComponent(
          url
        )}`,
      icon: FacebookFlat,
    },
    {
      name: "Twitter",
      url: ({ text, url }) =>
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          text
        )}&url=${url}&via=lonelyplanet`,

      icon: X,
    },
  ],
  getUrl: (platform, content) =>
    engine.platforms.find(p => p.name === platform).url(content),
};

export const getShareUrl = (mode, platform, data) => {
  if (!mode || !platform) {
    return false;
  }

  let url;
  switch (mode) {
    case "campaign":
      url = engine.getUrl(platform, {
        url: campaign.url,
        text: "Lonely Planet reveals its top picks of places to travel in 2025.",
      });
      break;
    case "category":
      url = engine.getUrl(platform, {
        url: `${campaign.url}/${data.category.name}`,
        text: `Lonely Planet reveals its top picks of ${
          pivots[data.category.name]
        } to travel in 2025.`,
      });
      break;
    case "destination":
      url = engine.getUrl(platform, {
        url: `${campaign.url}#${keyify(data.destination.name)}`,
        text: `Lonely Planet reveals ${data.destination.name} as a top travel pick in 2025`,
      });
      break;
    default:
      break;
  }

  return url;
};
